/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_Ankle_RInputs */

const en_us2_bodymap_region_ankle_r = /** @type {(inputs: Bodymap_Region_Ankle_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right ankle or foot`)
};

const pt_br2_bodymap_region_ankle_r = /** @type {(inputs: Bodymap_Region_Ankle_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornozelo ou pé direito`)
};

const es_419_bodymap_region_ankle_r = /** @type {(inputs: Bodymap_Region_Ankle_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tobillo o pie derecho`)
};

const pt_pt2_bodymap_region_ankle_r = /** @type {(inputs: Bodymap_Region_Ankle_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornozelo ou pé direito`)
};

const fr_fr2_bodymap_region_ankle_r = /** @type {(inputs: Bodymap_Region_Ankle_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheville ou pied droit`)
};

const de_de2_bodymap_region_ankle_r = /** @type {(inputs: Bodymap_Region_Ankle_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtes Sprunggelenk oder Fuß`)
};

const it_it2_bodymap_region_ankle_r = /** @type {(inputs: Bodymap_Region_Ankle_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caviglia o piede destro`)
};

/**
* | output |
* | --- |
* | "Right ankle or foot" |
*
* @param {Bodymap_Region_Ankle_RInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_ankle_r = /** @type {((inputs?: Bodymap_Region_Ankle_RInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_Ankle_RInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_ankle_r(inputs)
	if (locale === "es-419") return es_419_bodymap_region_ankle_r(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_ankle_r(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_ankle_r(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_ankle_r(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_ankle_r(inputs)
	return en_us2_bodymap_region_ankle_r(inputs)
});
export { bodymap_region_ankle_r as "bodymap.region.ankle_r" }